<script>
	import { projectSettings } from "../config";
	import { regFormPhone } from "../tealium";
</script>

<a
	class="ca-phone-link"
	target="_blank"
	href="tel:{projectSettings.phoneNumber}"
	title="Call {projectSettings.phoneNumber}"
	on:click={() => regFormPhone(projectSettings.phoneNumber)}
>
	<span style="white-space:nowrap">{projectSettings.phoneNumber}</span>
</a>
